import React from 'react';

const Waves = () => {
  return (
    <div className="waves">
      <div className="waves waves-left" />
      <div className="waves waves-right" />
    </div>
  );
};

export default Waves;